export const defaultPlantas = [
  { id: 'planta1', nombre: 'Planta Principal', centrosTrabajo: [
    { id: 'ct1_p1', nombre: 'Ensamblaje A' },
    { id: 'ct2_p1', nombre: 'Pintura B' },
    { id: 'ct3_p1', nombre: 'Control de Calidad' },
  ]},
  { id: 'planta2', nombre: 'Planta Norte', centrosTrabajo: [
    { id: 'ct1_p2', nombre: 'Corte Láser' },
    { id: 'ct2_p2', nombre: 'Soldadura' },
  ]},
  { id: 'planta3', nombre: 'Planta Sur', centrosTrabajo: [
    { id: 'ct1_p3', nombre: 'Empaque' },
    { id: 'ct2_p3', nombre: 'Almacén' },
  ]},
  { id: 'planta4', nombre: 'Planta Oeste', centrosTrabajo: [
    { id: 'ct1_p4', nombre: 'Mantenimiento' },
  ]},
];